const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');

function getS3KeyFromUrl(url) {
  if (!url || typeof url !== 'string') {
    return null;
  }

  try {
    const parsedUrl = new URL(url);
    if (!parsedUrl.hostname.endsWith('.amazonaws.com')) {
      return null;
    }

    const hostParts = parsedUrl.hostname.split('.');
    if (hostParts.length >= 5 && hostParts[1] === 's3') {
      return parsedUrl.pathname.replace(/^\/+/, '');
    }

    if (hostParts[0] === 's3' && parsedUrl.pathname) {
      const [, , ...keyParts] = parsedUrl.pathname.split('/');
      return keyParts.length ? keyParts.join('/') : null;
    }

    return null;
  } catch (_error) {
    return null;
  }
}

export function resolveMediaUrl(url, { preferProxy = false } = {}) {
  if (!url) {
    return url;
  }

  // Frontend-owned static assets must stay on the frontend origin. Uploaded
  // media paths are backend routes and need the configured API origin.
  if (url.startsWith('/assets/')) {
    return url;
  }

  if (url.startsWith('/')) {
    return `${BACKEND_URL}${url}`;
  }

  if (!preferProxy) {
    return url;
  }

  const s3Key = getS3KeyFromUrl(url);
  if (!s3Key) {
    return url;
  }

  return `${BACKEND_URL}/api/uploads/${s3Key}`;
}
